import React, { useContext } from 'react';
import { IsActiveDocContext } from '@/contexts/IsActiveDocContext';

interface DocHeadingProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const DocHeading: React.FC<DocHeadingProps> = ({ children, className, id }) => {
  const isActive = useContext(IsActiveDocContext);
  const cls = className ?? 'text-3xl font-bold text-gray-900 mb-4';
  if (isActive === false) {
    return (
      <h2 id={id} className={cls}>
        {children}
      </h2>
    );
  }
  return (
    <h1 id={id} className={cls}>
      {children}
    </h1>
  );
};

export default DocHeading;
